import React from "react";
import Scaffold from "../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../widget/common/ui/MainContainer";
import AppTranslation from "../../service/app_translation/AppTranslation";
import SearchContent from "./SearchContent";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import { SearchContextProvider } from "../../provider/search/SearchContextProvider";
import SearchActions from "./widget/SearchAction";

const SearchScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <SearchContextProvider>
      <Scaffold
        appBarTitle={AppTranslation.text("choose")}
        appBarAction={<SearchActions />}
      >
        <MainBodyContainer>
          <SearchContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </SearchContextProvider>
  );
};

export default SearchScreen;
export const routeName: string = "/search";
